export default __webpack_public_path__ + "static/media/icon-acionar-seguro.88d30724.svg";